import React from "react";

import { Link, useLocation } from "react-router-dom";

import "./sidebar.css";

import logo from "../../assets/images/logo.png";

import sidebar_items from "../../assets/JsonData/sidebar_routes.json";
import { useSelector } from "react-redux";
import packageInfo from "../../../package.json";
 

const SidebarItem = (props) => {
  const active = props.active ? "active" : "";

  return (
    <div className="sidebar__item">
      <div className={`sidebar__item-inner ${active}`}>
        <i className={props.icon}></i>
        <span>{props.title}</span>
      </div>
    </div>
  );
};
const BASIC_USER_ROUTES = ["Invoice","Dashboard","Suppliers","Brokers","Trips","Items","Price Update","Invoice List","Stock","Reports","Setting"];
const Sidebar = (props) => {
  const ReleaseType = process.env.REACT_APP_RELEASE_TYPE;
  const userState = useSelector((state) => state.userReducer);
  const { errorMessage, user, isLogin } = userState;
  const location = useLocation();
  const activeItem = sidebar_items.findIndex(
    (item) => item.route === location.pathname
  );

  // console.log("include test", BASIC_USER_ROUTES.includes("suppliers"));

  return (
    <div className="sidebar">
      <div className="sidebar__logo">
        <img src={logo} alt="company logo" />
      </div>

      {sidebar_items.map((item, index) => {

        return (
        isLogin && (
          user.role !== "" && user.role === "admin" ? (
            <Link to={item.route} key={index}>
              <SidebarItem
                title={item.display_name}
                icon={item.icon}
                active={index === activeItem}
              />
            </Link>
          ) : (
            BASIC_USER_ROUTES.includes(item.display_name) === true && (
              <Link to={item.route} key={index}>
                <SidebarItem
                  title={item.display_name}
                  icon={item.icon}
                  active={index === activeItem}
                />
              </Link>
            )
          )
        )  
      )
      
      })}

      <div
        style={{
          width: "100%",
          paddingTop: 100,
          padding: 20,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {
          console.log("process.env.RELEASE_TYPE", ReleaseType)
        }
        <h3>{ReleaseType || 'Dev'}</h3>
        <h4>Build version {packageInfo.version}</h4>
      </div>
    </div>
  );
};

export default Sidebar;
